var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-layout',[_c('common-content-spacer',{attrs:{"height":"medium"}},[_c('common-content-spacer',{attrs:{"height":"small"}},[_c('common-breadcrumbs',{attrs:{"breadcrumbs":_vm.pageBreadcrumbs}}),_c('common-page-header',{attrs:{"heading":_vm.pageTitle}})],1),_c('common-page-plain',[_c('practice-members-list')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }